import { createRouter, createWebHistory } from 'vue-router';
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css';
import { appRoutes } from './routes';
import routeGuard from './guard/index';

NProgress.configure({ showSpinner: false }); // NProgress Configuration

const routes = [
  {
    path: '/',
    redirect: { name: 'login' }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login/login.vue'),
    meta: {
      requiresAuth: false,
      hideInMenu: true
    }
  },
  {
    path: '/bridge',
    name: 'bridge',
    meta: {
      title: '跳转中',
      requiresAuth: true,
      hideChildrenInMenu: true,
      roles: 'bridge'
    }
  },
  {
    path: '/no-access',
    name: 'notAccess',
    component: () => import('@/views/access-denied/access-denied.vue'),
    meta: {
      requiresAuth: false,
      hideInMenu: true
    }
  },
  {
    path: '/other-errors',
    name: 'otherErrors',
    component: () => import('@/views/login-other-errors/login-other-errors.vue'),
    meta: {
      requiresAuth: false,
      hideInMenu: true
    }
  },
  ...appRoutes,
  {
    path: '/:pathMatch(.*)*',
    name: 'notFound',
    component: () => import('@/views/error-404/error-404.vue'),
    meta: {
      hideInMenu: true
    }
  }
];
console.log(39, routes);
// 创建路由
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    console.log('scrollBehavior', to, from, savedPosition);
    if (savedPosition) {
      return savedPosition;
    } else {
      return { left: 0, top: 0 };
    }
  }
});

// 处理push和replace
const op = router.push;
const or = router.replace;
function addRtParam(to, method) {
  if (to instanceof Object) {
    if (!to.query) {
      to.query = {};
    }
    if (!to.query.rt) {
      to.query.rt = method;
    }
  }
  return to;
}
router.push = function (to, rs, rj) {
  console.log(6999991, to);
  to = addRtParam(to, 'push');
  if (rs && rj) {
    return op.call(this, to, rs, rj);
  } else {
    return op.call(
      this,
      to,
      () => {},
      () => {}
    );
  }
};
router.replace = function (to, rs, rj) {
  console.log(6999991, to, to instanceof Object);
  to = addRtParam(to, 'replace');
  if (rs && rj) {
    return or.call(this, to, rs, rj);
  } else {
    return or.call(
      this,
      to,
      () => {},
      () => {}
    );
  }
};
routeGuard(router);

export default router;
